import axios from 'axios';

const apiV4 = axios.create({
    baseURL: '/api/v4',
    responseType: 'json',
});

export default apiV4;
